import SvgIcon from '@mui/material/SvgIcon';

export const IconClibboard = (props) => (
	<SvgIcon viewBox="0 0 12 12" fontSize="inherit" {...props}>
		<path d="M3.47444 11C2.48989 11 2 10.5149 2 9.54011V2.46455C2 1.4944 2.49465 1 3.47444 1H5.65755V4.42351C5.65755 5.02052 5.94768 5.30504 6.55648 5.30504H10V9.54011C10 10.5103 9.51011 11 8.52556 11H3.47444ZM6.57075 4.66604C6.39477 4.66604 6.30916 4.58209 6.30916 4.41418V1.05131C6.50892 1.08396 6.70392 1.21922 6.92747 1.4431L9.54816 4.0597C9.77646 4.28825 9.91439 4.47481 9.94292 4.66604H6.57075Z" />
	</SvgIcon>
);

export default IconClibboard;
